import { Form, Input, Select, Button } from 'antd'
import { useEffect, useState } from 'react'
import UserService from '../../../@services/user'

/* eslint-disable no-template-curly-in-string */
const validateMessages = {
  required: '请输入${label}',
}

export default function FormPage(props) {
  const { originForm } = props
  const [form] = Form.useForm(originForm)
  const [roleSelectProps, setRoleSelectProps] = useState({
    options: [],
    mode: 'multiple',
    loading: false,
  })

  const [storeSelectProps, setStoreSelectProps] = useState({
    options: [],
    mode: 'multiple',
    loading: false,
  })

  const [allStoreCodes, setAllStoreCodes] = useState([])
  const [isSelectAllStore, setIsSelectAllStore] = useState(false)

  const selectAllStore = () => {
    form.setFieldsValue({ stores: [...allStoreCodes] })
    setIsSelectAllStore(true)
  }

  const onFormValuesChange = (changedValues, allValues) => {
    setIsSelectAllStore(allValues.stores.length === allStoreCodes.length)
  }

  const [isEdit, setIsEdit] = useState(false)
  useEffect(() => {
    const getStore = async () => {
      try {
        setStoreSelectProps(state => ({ ...state, loading: true }))
        const res = (await UserService.getStore()) || []
        const options = []
        const storeAllCodes = []
        res.forEach(item => {
          options.push({
            label: item.storeName,
            value: item.storeCode,
          })
          storeAllCodes.push(item.storeCode)
        })

        const info = form.getFieldsValue()
        setIsSelectAllStore(info.stores.length === storeAllCodes.length)

        setAllStoreCodes(storeAllCodes)
        setStoreSelectProps(state => ({
          ...state,
          options,
        }))
      } catch (error) {
        console.log({ error })
      } finally {
        setStoreSelectProps(state => ({ ...state, loading: false }))
      }
    }

    const getRoleList = async () => {
      try {
        setRoleSelectProps(state => ({ ...state, loading: true }))
        const res = (await UserService.getAllRoleList()) || []
        setRoleSelectProps(state => ({
          ...state,
          options: (res || []).map(item => ({
            label: item.name,
            value: item.id,
          })),
        }))
      } catch (error) {
        console.log({ error })
      } finally {
        setRoleSelectProps(state => ({ ...state, loading: false }))
      }
    }

    getRoleList()
    getStore()
    const user = form.getFieldsValue()
    setIsEdit(!!user.id)
  }, [form])

  return (
    <Form
      form={form}
      labelCol={{ span: 4 }}
      wrapperCol={{ span: 18 }}
      validateMessages={validateMessages}
      onValuesChange={onFormValuesChange}
    >
      <Form.Item name={'id'} style={{ display: 'none' }}>
        <></>
      </Form.Item>
      <Form.Item name={'status'} style={{ display: 'none' }}>
        <></>
      </Form.Item>
      <Form.Item name={'type'} style={{ display: 'none' }}>
        <></>
      </Form.Item>
      
      <Form.Item
        name="username"
        label="账号"
        rules={[
          {
            required: true,
          },
          {
            validator(_, value) {
              if (!/^[\da-zA-Z]+$/.test(value)) {
                return Promise.reject('账号只能为字母或数字组成')
              }
              if (value.length > 10) {
                return Promise.reject('账号不能超过10个字符')
              }
              return Promise.resolve()
            },
          },
        ]}
      >
        <Input placeholder="请输入角色名称" />
      </Form.Item>

      <Form.Item
        name="name"
        label="姓名"
        rules={[
          { required: true },
          {
            validator(_, value) {
              if (!/^[\u4e00-\u9fa5]+$/.test(value)) {
                return Promise.reject('姓名只能为中文')
              }
              if (value.length > 10) {
                return Promise.reject('姓名不能超过10个字符')
              }
              return Promise.resolve()
            },
          },
        ]}
      >
        <Input placeholder="请输入姓名" />
      </Form.Item>

      {isEdit || (
        <Form.Item
          name="password"
          label="初始密码"
          rules={[
            { required: true },
            {
              validator(_, value) {
                if (value.length < 6) {
                  return Promise.reject('初始密码不能少于6个字符')
                }
                if (value.length > 20) {
                  return Promise.reject('初始密码不能超过20个字符')
                }
                return Promise.resolve()
              },
            },
          ]}
        >
          <Input placeholder="请输入初始密码" />
        </Form.Item>
      )}

      <Form.Item name="roles" label="角色权限">
        <Select {...roleSelectProps} />
      </Form.Item>

      <Form.Item
        name="stores"
        label="数据权限"
        style={isSelectAllStore ? {} : { marginBottom: '3px' }}
      >
        <Select {...storeSelectProps} />
      </Form.Item>
      {isSelectAllStore ? null : (
        <Form.Item label={` `} colon={false}>
          <Button
            type="primary"
            style={{ marginTop: '5px' }}
            onClick={selectAllStore}
          >
            全部门店
          </Button>
        </Form.Item>
      )}

      <Form.Item name="remark" label="备注">
        <Input.TextArea
          placeholder="请输入备注"
          autoSize={{ minRows: 4, maxRows: 10 }}
        />
      </Form.Item>
    </Form>
  )
}
